import { useQuery } from 'react-query';

import VehicleService from '../../../services/VehicleService';
import { VEHICLE } from '../../constants/queryDefinition';

interface Manufacturer {
  id: number;
  displayName: string;
  isVisible: boolean;
}

const useManufacturerList = () => {
  async function getManufacturerList(): Promise<Array<Manufacturer>> {
    const vehicleService = VehicleService.get();
    const manufacturerListResponse = await vehicleService.getManufacturerList();

    return manufacturerListResponse;
  }

  const manufacturerList = useQuery(
    VEHICLE.MANUFACTURERLIST,
    getManufacturerList,
    {
      enabled: true,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      cacheTime: VEHICLE.REFETCH_INTERVAL,
      staleTime: VEHICLE.REFETCH_INTERVAL,
      placeholderData: []
    }
  );

  return manufacturerList;
};

export default useManufacturerList;
